import { useContext, useState } from "react";
import "./style.css";
import { DropboxArrowIcon } from "../../../../../components/GlobalIcons";
import StockQuantity from "../../StockQuantity";
import { filterDataContext } from "../../../../../App";




const CartPrice = ({ items, ticketName , reserveTicket ,  showNotifyPopUp, setShowNotifyPopUp
}) => {
  const { reservationData, setReserVationData } = useContext(filterDataContext)
  return (
    <div className="CartPrice_multiple card">
      <span className="drop_icon">
        <DropboxArrowIcon />
      </span>
      <div className="ticket_multiply_sec">
        {items?.map((item, index) => {
          return (
            <StockQuantity item={item} key={index}
              ticketName={ticketName}
              reservationData={reservationData} setReserVationData={setReserVationData}
              alreadySelectQuantity={reservationData?.find(data => data.ticket_id === item.ticket_id)?.quantity}
              reserveTicket={reserveTicket}
              showNotifyPopUp={showNotifyPopUp} setShowNotifyPopUp={setShowNotifyPopUp}

            />
          )
        })}
      </div>
    </div>
  );
};

export default CartPrice;
